import { Filter } from "@/shared/lib/filter/filter";
import { backendApi } from "@/services/backend/api";
import { Branch, BranchList } from "@/services/backend/company/types/branch";

const branchApi = backendApi.injectEndpoints({
  endpoints: (build) => ({
    putBranch: build.mutation<Branch, PutBranchRequest>({
      query: (request) => ({
        url: `companies/branch`,
        method: "PUT",
        body: request,
      }),
      invalidatesTags: ["Branch"],
    }),
    branchesBranchShow: build.query<Branch, ShowBranchRequest>({
      query: (request) => ({
        url: `companies/branch`,
        method: "GET",
        params: request,
      }),
      providesTags: (result) =>
        result ? [{ type: "Branch", id: result.id }] : [],
    }),
    listBranch: build.query<BranchList, ListBranchRequest>({
      query: (request) => ({
        url: `companies/branch/list`,
        method: "GET",
        params: {
          request: btoa(JSON.stringify(request)),
        },
      }),
      providesTags: (result) =>
        result
          ? result.branches?.map((p) => ({ type: "Branch", id: p.id }))
          : [{ type: "Branch", id: "LIST" }],
    }),
    deleteBranch: build.mutation<Branch, DeleteBranchRequest>({
      query: (request) => ({
        url: `companies/branch`,
        method: "DELETE",
        body: request,
      }),
      invalidatesTags: ["Branch"],
    }),
  }),
});

export const {
  usePutBranchMutation,
  useBranchesBranchShowQuery,
  useListBranchQuery,
  useDeleteBranchMutation,
} = branchApi;

export type PutBranchRequest = Branch;

export interface ShowBranchRequest {
  id: string;
}

export interface DeleteBranchRequest {
  id: string;
}

export interface ListBranchRequest {
  id?: Filter<string>;
  company?: Filter<string>;
  name?: Filter<string>;
}
